module.exports = __webpack_public_path__ + "img/plus_ads.bcf809c7.png";